import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import persistState from 'redux-localstorage';
import thunk from 'redux-thunk';

import rootReducer from './reducers/index';

const enhancers = composeWithDevTools(
  persistState(['auth', 'outgoingLotsOverview']),
  applyMiddleware(thunk),
);

const defaultState = {};

const store = createStore(rootReducer, defaultState, enhancers);

export default store;
